<template>

    <div class="product-detail" :id="`product_sku__${product.sku}`">
        <h1 class="page-title text-center" v-if="title">{{ title }}</h1>
        <div class="container pd-sm-0">
            <div v-if="ready">
                <product-list-item
                    v-show="product.sku"
                    extraClasses="product--inline"
                    :product="product"
                    :initialQuantity="1"
                    :cartMode="false"
                    :showAttributes="true"
                    :useCarousel="true"
                    :titleAsLink="false"
                    :showTimeBeforeAvailable="true" />

                <!-- <div class="product__detail block-primary"> -->
                    <div v-html="product.description"></div>
                    <div class="alert alert--danger text-left" v-if="product.notice">
                        <strong>หมายเหตุ</strong>
                        <div v-html="product.notice"></div>
                    </div>
                <!-- </div> -->
            </div>

            <div v-if="!ready">
                <loader></loader>
            </div>
        </div>
        <banner></banner>
    </div>
</template>

<script>
import ProductListItem from './ProductListItem.vue'
import Loader from './Loader.vue'
import Banner from './Banner.vue'

export default {
  components: {
    Loader,
    Banner,
    ProductListItem
  },
  name: 'ProductDetail',
  props: {
    product: { type: Object, required: true }
  },
  data () {
    return {
      catalogItems: [],
      catalogItemsLoading: false,
      catalogItemsError: false,
      title: 'บริจาค'
    }
  },
  mounted () {
    this.fetchCatalogItems(this.product.sku)

    if (this.$route.query.type === 'monthly') {
      this.title = 'บริจาครายเดือน'
    }
  },
  computed: {
    ready () {
      return this.product && this.product.sku
    }
  },
  methods: {
    fetchCatalogItems (sku) {
      if (this.catalogItemsLoading) {
        return
      }

      // if (sku === 'phapa') {
      //   // window.location = this.$utils.getWpPath('')
      //   // return
      // }

      this.catalogItemsLoading = true
      this.catalogItemsError = false

      const params = {
        showUnlisted: true,
        catalogSku: sku
      }

      return this.$http.get('products', { params: params })
        .then(resp => {
          this.catalogItemsLoading = false
          this.catalogItems = resp.body.products
        })
        .catch(err => {
          console.log(err)
          this.catalogItemsLoading = false
          this.catalogItemsError = true
        })
    }
  },
  watch: {
    product: function () {
      // load catalog
      if (this.product && this.product.type === this.$const.PRODUCT_TYPES.CATALOG) {
        this.fetchCatalogItems(this.product.sku)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.product-list-item {
  background-color: #f8f8f8;
}

.product__catalog_items .product-list-item {
  background-color: inherit;
}
.page-title {
  color: #fff;
  text-shadow: 2px 2px 2px rgba(0,0,0,0.5);
  font-size: 2em;
  font-weight: 400;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// ProductDetail.vue?7b28c3f5